<div style="display: flex; flex-direction: column">
    <div style="flex-basis: 50%">
        <app-shopee-orders title="Shopee (genlogic)"></app-shopee-orders>
    </div>
</div>
